import { formatTimeToStr } from "../filter/dateUtils";
import i18n from "@src/common/lib/i18n";
export const api = {
  addDatabaseBackup: "/dfx/databasebackup/addDatabaseBackup.json", //  新增数据库备份
  queryDatabaseBackupList: "/dfx/databasebackup/queryDatabaseBackupList.json", //查询数据库备份列表
  deleteDatabaseBackup: "/dfx/databasebackup/deleteDatabaseBackup.json", //删除数据库备份记录
  queryLog: "cms/log/queryResultsByPage.json"
};

export function downLoad({
  endTime = "",
  operate = "",
  operatorName = "",
  operateFunction = "",
  operateModule = "",
  operateType = "",
  startTime = "",
  self = undefined
}) {
  let params = {
    operate: operate,
    operatorName: operatorName,
    operateFunction: operateFunction,
    operateModule: operateModule,
    operateType: operateType,
    startTime: startTime,
    endTime: endTime
  };
  self
    .$fetchDownLoad("cms/log/export.json", params, {
      responseType: "arraybuffer"
    })
    .then((response) => {
      if (response.data.msgCode == "0") {
        // 会话超时
        return;
      }
      const content = response.data;
      const blob = new Blob([content], { type: "application/vnd.ms-excel" });

      const fileName =
        i18n.t("log.title.exportName") +
        formatTimeToStr(new Date().getTime(), "yyyyMMddhhmmss") +
        ".xlsx";
      if ("download" in document.createElement("a")) {
        // 非IE下载
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    });
}
